var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mb-2 flex" }, [
    _c("p", { staticClass: "mr-1" }, [_vm._v(" " + _vm._s(_vm.title) + " ")]),
    _c(
      "div",
      [
        _vm._t("default", function () {
          return [
            _vm.content
              ? _c("p", [_vm._v(" " + _vm._s(_vm.content) + " ")])
              : _c("p", { staticClass: "text-gray-400" }, [
                  _vm._v(" " + _vm._s(_vm.placeholder) + " "),
                ]),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }